import { useEffect, useRef, useState } from "react";
import { useLoggerState } from "../../helpers";
import Text, { TypographyProps } from "@mui/material/Typography";

type StatusLabelProps = {
    idleText?: string;
    slotProps?: {
        text?: TypographyProps;
    }
}
export default function StatusLabel({ idleText = "Status: Idle", slotProps }: StatusLabelProps) {
    const [lastMessage] = useLoggerState();
    const [displayText, setDisplayText] = useState<string>(idleText);
    const timerRef = useRef<number | null>(null);

    // Safely extract a string from lastMessage
    const lastMessageText: string | undefined = (() => {
        if (typeof lastMessage === "string") return lastMessage;
        // Try common fields
        const msg = (lastMessage as any)?.message ?? (lastMessage as any)?.text ?? (lastMessage as any)?.toString?.();
        if (typeof msg === "string") return msg;
        try {
            return lastMessage ? JSON.stringify(lastMessage) : undefined;
        } catch {
            return undefined;
        }
    })();

    // Update display text when a new message arrives
    useEffect(() => {
        if (lastMessageText && lastMessageText.length > 0) {
            setDisplayText(lastMessageText);
        }
        // Clear previous timer
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        // Start inactivity timer to reset to idle after 5 seconds
        timerRef.current = window.setTimeout(() => {
            setDisplayText(idleText);
        }, 5000);

        // Cleanup on unmount
        return () => {
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
        // Re-run when lastMessage or idleText changes
    }, [lastMessageText, idleText]);

    return (
        <Text variant="caption" component="span" {...slotProps?.text}>
            {displayText}
        </Text>
    );
}